import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import { Grid, Typography, FormHelperText } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import Checkbox from './Checkbox';
import HSpacer from './HSpacer';
import { validate as commonValidate } from './common';

var styles = function styles(theme) {
  return {
    text: {
      flex: 'auto',
      fallbacks: [{
        width: 'min-content'
      }, {
        width: '-moz-min-content'
      }]
    }
  };
};

var FormCheckbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormCheckbox, _React$Component);

  function FormCheckbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormCheckbox);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormCheckbox)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      checked: _this.props.checked || false
    }, _this.validate = function () {
      return commonValidate(_assertThisInitialized(_this), _this.state.checked);
    }, _this.handleChange = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          lazyValidation = _this$props.lazyValidation;
      var newVal = !_this.state.checked;

      if (onChange !== undefined) {
        onChange(newVal);
      }

      _this.setState({
        checked: newVal
      }, lazyValidation === undefined || lazyValidation === false ? _this.validate : function () {});
    }, _temp));
  }

  _createClass(FormCheckbox, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          label = _props.label,
          onChange = _props.onChange,
          classes = _props.classes,
          checked = _props.checked,
          labelComponent = _props.labelComponent,
          errorMessages = _props.errorMessages,
          lazyValidation = _props.lazyValidation,
          other = _objectWithoutProperties(_props, ['label', 'onChange', 'classes', 'checked', 'labelComponent', 'errorMessages', 'lazyValidation']);

      var errorMessage = this.state.errorMessage;
      return React.createElement(Grid, {
        container: true,
        direction: 'column'
      }, React.createElement(Grid, _extends({
        container: true,
        alignItems: 'center',
        direction: 'row'
      }, other), React.createElement(Grid, {
        item: true,
        style: {
          flex: '0 0 24px'
        }
      }, React.createElement(Checkbox, {
        checked: checked,
        onChange: this.handleChange
      })), React.createElement(HSpacer, {
        small: true
      }), React.createElement(Grid, {
        item: true,
        className: classes.text
      }, label && React.createElement(Typography, null, label), labelComponent)), React.createElement(FormHelperText, {
        style: {
          color: '#FF2825'
        }
      }, errorMessage));
    }
  }]);

  return FormCheckbox;
}(React.Component);

FormCheckbox.propTypes = {
  checked: PropTypes.bool
};
FormCheckbox.defaultProps = {
  checked: false
};
export default withStyles(styles)(FormCheckbox);